
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  
  const faqs = [
    {
      question: t('Is it one-on-one lessons?'),
      answer: t('Yes, it\'s one-on-one. We provide coaching not only during lessons but also create proper learning menus for daily study to help you become able to speak.')
    },
    {
      question: t('What payment methods are available?'),
      answer: t('We accept bank transfer. Students are responsible for transfer fees.')
    },
    {
      question: t('Are lesson days fixed?'),
      answer: t('Monday to Saturday, we set up classes from 10am to 9pm according to students\' convenience.')
    },
    {
      question: t('How do I make reservations?'),
      answer: t('Please contact us through our official Instagram or email address, and we will adjust the schedule individually.')
    }
  ];
  
  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('Frequently Asked Questions')}
          </h2>
        </div>
        
        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <Card key={index} className="mb-4">
              <button
                className="w-full p-6 text-left flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'} text-xl text-orange-500`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <div className="border-t border-gray-200 pt-4">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
